<template>
  <div v-if="trip">
    <div class="container trip-container pt-30 pb-80">
      <div class="row">
        <div class="col-xl-12">
          <!-- <trip-card-thin :trip="trip" /> -->
          <!-- Planned Trip -->
          <template v-if="trip.type=='Planned'">
            <planned-trip-card :trip="trip"></planned-trip-card>				
          </template>
				<!-- Proposed Trip -->
          <template v-if="trip.type=='Proposed'">
            <proposed-trip-card :trip="trip"></proposed-trip-card>
          </template>
        </div>
      </div>
      <template v-if="showNote">
        <note-card :description="trip.description"></note-card>
      </template>
    </div>
  </div>
</template>

<script>
import httpClient from '@/utils/httpClient';
// import TripCardThin from "@/components/Trip/TripCardThin";
import PlannedTripCard from './Cards/PlannedTripCard';
import ProposedTripCard from './Cards/ProposedTripCard';	
import NoteCard from './Cards/NoteCard';	
import moment from "moment";

export default {
  components: {
    PlannedTripCard,
    ProposedTripCard,
    NoteCard
  },
  data () {
    return {
      tripId: null,
      trip: null
    }
  },
  created () {
    this.tripId = +this.$route.params.trip ? +this.$route.params.trip : "";
    if (this.tripId) {
      this.fetchTrip();
    }
  },
  methods: {
    fetchTrip() {
      if (this.email) {
        const params = {
          params: {
              email: this.email,
          }
        };
        httpClient.get(`/api/trip/${this.tripId}`,params).then(res => {
          this.trip = res.data;
        });
      }
      else {
        httpClient.get(`/api/trip/${this.tripId}`).then(res => {
          this.trip = res.data;
        });
      }
    },
    getFormattedDate(dateTrip) {
      return moment(dateTrip, "YYYY-MM-DD").format("MM-DD-YYYY");
    },
    conversationStatusLabel (conversation) {
      if(conversation.status == 3) {
        return 'MEETING CONFIRMED'
      }
      if(conversation.status == 4) {
        return 'CONVERSATION ARCHIVED'
      }
      return 'ACTIVE CONVERSATION'
    },
    conversationStatusClass (conversation) {
      if(conversation.status == 3) {
        return 'bg-success'
      }
      if(conversation.status == 4) {
        return 'bg-dark'
      }
      return 'bg-light-blue'
    },
  },
  computed: {
    showNote: function() {
      return this.trip.description && this.$store.state.users.user && this.$store.state.users.user.role &&this.$store.state.users.user.role.name == 'admin';
    },
    email() {
            return this.$store.state.guests.email ||
                localStorage.getItem('guest_email') ||
                ''
        },
  }
}
</script>

<style scoped>
.trip-container.container {
  width: 90%;
	padding-right: 15px;
	padding-left: 15px;
	margin-right: auto;
	margin-left: auto;
}
@media (min-width: 576px) {
	.trip-container.container {
		max-width: 100%;
	}
}
@media (min-width: 576px) {
	.trip-container.container {
		max-width: 540px;
	}
}
@media (min-width: 768px) {
	.trip-container.container {
		max-width: 720px;
	}
}
@media (min-width: 1200px) {
	.trip-container.container {
		max-width: 1140px;
	}
}			

@media (max-width: 768px) {
    .flight-details .header-list > span {
        flex: 1 1 auto!important;
    }
}
.conversation-container {
  width: 100%;
}
</style>